// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const type_null: PokeData = {
  "id": 772,
  "name": "type-null",
  "height": 19,
  "weight": 1205,
  "base_experience": 107,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "razor-wind",
    "tackle",
    "take-down",
    "double-edge",
    "rage",
    "tri-attack",
    "scary-face",
    "pursuit",
    "imprison",
    "crush-claw",
    "metal-sound",
    "aerial-ace",
    "heal-block",
    "punishment",
    "air-slash",
    "x-scissor",
    "iron-head",
    "double-hit"
  ],
  "moves": [
    "tackle",
    "tri-attack",
    "scary-face",
    "pursuit",
    "metal-sound",
    "aerial-ace",
    "air-slash",
    "headbutt",
    "growl",
    "refresh",
    "supersonic",
    "body-slam",
    "scratch"
  ],
  "evolution_chain": {
    "id": 399,
    "item": null,
    "species": [
      {
        "name": "type-null",
        "order": 772,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "silvally",
        "order": 773,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 772,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 59,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
